/**
 * Step 6: Reliability Metrics
 */
import React, { useEffect } from 'react';
import { Form, InputNumber, Input, Switch } from 'antd';

const { TextArea } = Input;

interface Step6Props {
  data: any;
  onChange: (data: any) => void;
}

const Step6Reliability: React.FC<Step6Props> = ({ data, onChange }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(data);
  }, [data, form]);

  const handleValuesChange = (_: any, allValues: any) => {
    onChange(allValues);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onValuesChange={handleValuesChange}
      initialValues={data}
    >
      <Form.Item label="样本量" name="sample_size">
        <InputNumber min={1} style={{ width: '100%' }} placeholder="例如: 120" />
      </Form.Item>

      <Form.Item label="研究设计" name="study_design">
        <Input placeholder="例如: prospective pharmacokinetic study" />
      </Form.Item>

      <Form.Item label="外部验证" name="external_validation_performed" valuePropName="checked">
        <Switch />
      </Form.Item>

      <Form.Item label="MPE (Mean Prediction Error)" name="mpe">
        <InputNumber style={{ width: '100%' }} placeholder="例如: -2.5" />
      </Form.Item>

      <Form.Item label="MAPE (Mean Absolute Prediction Error %)" name="mape">
        <InputNumber min={0} max={100} style={{ width: '100%' }} placeholder="例如: 15.3" />
      </Form.Item>

      <Form.Item label="RMSE (Root Mean Square Error)" name="rmse">
        <InputNumber min={0} style={{ width: '100%' }} placeholder="例如: 3.2" />
      </Form.Item>

      <Form.Item label="Bootstrap 或其他验证方法" name="bootstrap_or_other">
        <TextArea rows={3} placeholder="例如: Bootstrap (n=1000), 成功率 95%" />
      </Form.Item>
    </Form>
  );
};

export default Step6Reliability;
